{
    "Accessibility menu": "ადაპტირებული მენიუ",
    "Close": "დახურვა",
    "Content adjustments": "შიგთავსის მორგება",
    "Navigation adjustments": "ნავიგაციის მორგება",
    "Text Align": "Text Align",
    "Align Left": "მარცხნივ გასწორება",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "ფონტის ზომის მორგება",
    "Highlight Title": "სათაურების გამოყოფა",
    "Highlight Links": "ბმულების გამოყოფა",
    "Readable Font": "წაკითხვადი ტექსტები",
    "Colour adjustments": "ფერების მორგება",
    "Dark Contrast": "ბნელი ელფერი",
    "Light Contrast": "ნათელი ელფერი",
    "High Contrast": "მაღალი ელფერი",
    "High Saturation": "მაღალი გაჯერება",
    "Low Saturation": "დაბალი გაჯერება",
    "Monochrome": "ერთფეროვანი გამოსახულება",
    "Tools": "ხელსაწყოები",
    "Reading Guide": "კითხვის გამყოლი ზოლი",
    "Big Cursor": "დიდი კურსორი",
    "Increase Font Size": "ფონტის ზომის გაზრდა",
    "Decrease Font Size": "ფონტის ზომის შემცირება",
    "Letter Spacing": "ასოებს შორის დაშორება",
    "Line Height": "ხაზის სიმაღლე",
    "Font Weight": "ფონტის წონა",
    "Dyslexia Font": "დისლექსიური ფონტი",
    "Language": "ენა",
    "Accessibility widget": "გახსენი ადაპტირებული მენიუ",
    "Accessibility Profiles": "ადაპტირებული პროფილები",
    "Cognitive Disability": "კოგნიტიური შეზღუდვა",
    "Seizure Safe": "უსაფრთხო ეპილეფსიისთვის",
    "Accessibility statement": "ადაპტირების დეკლარაცია",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "ანიმაციების გაჩერება",
    "Reset all settings": "პარამეტრების დაბრუნება",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
